/* Viora extras: effects & interactions */
(function(){
  /* Guard against this file ever loading twice on the same page (e.g. if a
     page's layout accidentally includes it more than once) — without this,
     every click handler below would register twice, and something like the
     accordion toggle would fire twice per click and immediately undo itself. */
  if (window.__vioraExtrasLoaded) return;
  window.__vioraExtrasLoaded = true;

  /* ---------- Accordion toggle (.acc-item / .acc-head) ----------
     Registered first, before anything else in this file, so a problem in
     any other feature below can never stop this from working. */
  document.addEventListener('click', function(e){
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var item = head.closest('.acc-item');
    if (!item) return;
    item.classList.toggle('open');
    head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
  });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 4) Scroll-in reveals ---------- */
  var revealTargets = document.querySelectorAll('.p-card,.review,.cond-card,.info-card,.tile,.section-head,.trust-item,.pulled-stage,.stat-item');
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) {
          en.target.classList.add('in-view');
          io.unobserve(en.target);
          if (en.target.classList.contains('stat-item')) countUp(en.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(function(el, i){
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 90 + 'ms';
      io.observe(el);
    });
  } else {
    revealTargets.forEach(function(el){ el.classList.add('in-view'); if (el.classList.contains('stat-item')) countUp(el, true); });
  }

  /* ---------- 11) Count-up stats ---------- */
  function countUp(item, instant){
    var numEl = item.querySelector('.stat-num');
    if (!numEl || numEl.dataset.done) return;
    numEl.dataset.done = '1';
    var raw = numEl.dataset.value || numEl.textContent;
    var m = raw.replace(/,/g,'').match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
    if (!m) return;
    var prefix = m[1], target = parseFloat(m[2]), suffix = m[3];
    if (instant || reduced) { numEl.textContent = raw; return; }
    var start = null, dur = 1400;
    function fmt(n){ return Math.round(n).toLocaleString('en-US'); }
    function step(ts){
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      numEl.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else numEl.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  /* ---------- 12) Back-to-top button ---------- */
  var toTop = document.querySelector('.to-top');
  if (toTop) {
    window.addEventListener('scroll', function(){
      toTop.classList.toggle('show', window.scrollY > 600);
    }, { passive: true });
    toTop.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Mobile menu (robust open/close) ---------- */
  document.addEventListener('click', function(e){
    if (e.target.closest('.menu-toggle')) { document.body.classList.add('menu-open'); }
    if (e.target.closest('.m-close') || e.target.classList.contains('mobile-veil')) {
      document.body.classList.remove('menu-open');
    }
  });

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg){
    var t = document.getElementById('VToast');
    if (!t) return;
    t.querySelector('span:last-child').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }

  function refreshCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  }

  /* ---------- 7) Confetti ---------- */
  var FOIL = ['#7de2ff','#a78bfa','#f0a6ff','#8be8c9','#4F42C9'];
  function confetti(x, y){
    for (var i = 0; i < 26; i++) {
      var b = document.createElement('div');
      b.className = 'confetti-bit';
      b.style.left = x + 'px';
      b.style.top = y + 'px';
      b.style.background = FOIL[i % FOIL.length];
      b.style.setProperty('--dx', (Math.random() * 240 - 120) + 'px');
      b.style.setProperty('--dy', (-(Math.random() * 160) - 60) + 'px');
      b.style.setProperty('--rot', (Math.random() * 540 - 270) + 'deg');
      b.style.animationDelay = (Math.random() * 0.12) + 's';
      document.body.appendChild(b);
      (function(bit){ setTimeout(function(){ bit.remove(); }, 1400); })(b);
    }
  }

  /* Confetti bursts the moment any add-to-cart button is tapped */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.add-btn, .mobile-buy button');
    if (!b || b.disabled) return;
    var r = b.getBoundingClientRect();
    confetti(r.left + r.width/2, r.top + r.height/2);
  });

  /* ---------- Product page: AJAX add-to-cart + confetti ---------- */
  var pform = document.getElementById('ProductForm');
  var pdata = window.VIORA_PRODUCT || null;
  if (pform) {
    pform.addEventListener('submit', function(e){
      // Buy It Now keeps its native submit (goes straight to checkout)
      if (e.submitter && e.submitter.classList.contains('buy-now')) return;
      e.preventDefault();
      var btn = pform.querySelector('.add-btn');
      var rect = btn ? btn.getBoundingClientRect() : { left: innerWidth/2, top: innerHeight/2, width: 0, height: 0 };
      fetch('/cart/add', { method: 'POST', body: new FormData(pform), headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw 0; return r.json(); })
        .then(function(){
          refreshCartCount();
          if (window.VioraCart && window.VioraCart.open) { window.VioraCart.open(); }
          else { toast('Added to cart'); }
        })
        .catch(function(){ pform.submit(); });
    });
  }

  /* ---------- 9) Sticky mobile buy bar ---------- */
  var mbar = document.getElementById('MobileBuy');
  if (mbar && pform && 'IntersectionObserver' in window) {
    var buyRow = pform.querySelector('.buy-row') || pform;
    var mio = new IntersectionObserver(function(entries){
      mbar.classList.toggle('on', !entries[0].isIntersecting);
    }, { threshold: 0 });
    mio.observe(buyRow);
    var mbtn = mbar.querySelector('button');
    if (mbtn) mbtn.addEventListener('click', function(){
      var addBtn = pform.querySelector('.add-btn');
      if (addBtn && !addBtn.disabled) addBtn.click();
    });
  }

  /* ---------- 1) Holo tilt on the product image ---------- */
  var tilt = document.querySelector('.pd-main.tilt');
  if (tilt && !reduced) {
    var inner = tilt.querySelector('.tilt-inner');
    tilt.addEventListener('pointermove', function(e){
      var r = tilt.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      inner.style.transform = 'rotateY(' + ((px - 0.5) * 14) + 'deg) rotateX(' + ((0.5 - py) * 14) + 'deg)';
      tilt.style.setProperty('--mx', (px * 100) + '%');
      tilt.style.setProperty('--my', (py * 100) + '%');
    });
    tilt.addEventListener('pointerleave', function(){
      inner.style.transform = 'rotateY(0) rotateX(0)';
    });
  }

  /* ---------- 5) Recently viewed ---------- */
  var KEY = 'viora_recent';
  function getRecent(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  var strip = document.getElementById('RecentStrip');
  if (strip && pdata) {
    var items = getRecent().filter(function(p){ return p.handle !== pdata.handle; }).slice(0, 4);
    if (items.length > 0) {
      var recentWrap = strip.closest('.recent-wrap');
      if (recentWrap) recentWrap.style.display = '';
      items.forEach(function(p){
        var a = document.createElement('a');
        a.className = 'recent-card';
        a.href = p.url;
        a.innerHTML = (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '<span class="recent-title"></span><span class="recent-price"></span>';
        a.querySelector('.recent-title').textContent = p.title;
        a.querySelector('.recent-price').innerHTML = p.price;
        strip.appendChild(a);
      });
    }
    try {
      var list = getRecent().filter(function(p){ return p.handle !== pdata.handle; });
      list.unshift({ handle: pdata.handle, title: pdata.title, url: pdata.url, image: pdata.image, price: pdata.price });
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
    } catch(e){}
  }

/* ---------- 12) Accordion toggle (.acc-item / .acc-head) ---------- */
/* moved to the top of this file — see the comment there */

/* ---------- 13) Holo foil shimmer for review stars ----------
   JS-driven (not CSS keyframes) so it still runs with iOS Reduce Motion / Low Power Mode. */
(function(){
  var root=document.documentElement, start=null, last=0;
  function tick(t){
    if(start===null) start=t;
    if(t-last>33){ // ~30fps is plenty for a slow shimmer
      var p=((t-start)/7000)%1;            // 7s cycle, same as the logo
      var x=(p<.5?p*2:(1-p)*2)*100;         // 0% -> 100% -> 0%
      root.style.setProperty('--vr-foil-x',x.toFixed(1)+'%');
      last=t;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/* ---------- 14) Bundle quick add ("Complete the setup") ---------- */
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-bundle-add]');
  if (!btn || btn.disabled) return;
  /* icon-only buttons (data-icon) keep their icon: they get a busy, done or error state instead of text */
  var label = btn.innerHTML, icon = btn.hasAttribute('data-icon');
  var set = function (txt, cls) {
    if (!icon) { btn.textContent = txt; return; }
    btn.classList.remove('is-busy', 'is-done', 'is-err');
    if (cls) btn.classList.add(cls);
    if (cls === 'is-done') btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  };
  var reset = function () { btn.disabled = false; btn.classList.remove('is-busy', 'is-done', 'is-err'); btn.innerHTML = label; };
  btn.disabled = true; set('Adding...', 'is-busy');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: parseInt(btn.getAttribute('data-bundle-add'), 10), quantity: 1 })
  }).then(function(r){ if(!r.ok) throw r; return r.json(); })
    .then(function(){
      set('Added', 'is-done');
      if (window.VioraCart && window.VioraCart.open) window.VioraCart.open();
      setTimeout(reset, 1800);
    })
    .catch(function(){
      set('Try again', 'is-err');
      setTimeout(reset, 1800);
    });
});

/* ---------- 15) Live Judge.me reviews on the homepage ----------
   Reads the hidden Judge.me All Reviews widget and rebuilds each review
   as a Viora card with the product photo, customer photos and foil stars. */
(function(){
  var box = document.getElementById('LiveReviews');
  if (!box) return;
  var src = box.querySelector('[data-lr-source]');
  var track = box.querySelector('[data-lr-track]');
  var shell = box.querySelector('.lr-shell');
  if (!src || !track) return;
  var built = false, imgCache = {};

  function esc(t){ var d=document.createElement('div'); d.textContent=t||''; return d.innerHTML; }
  function txt(el, sel){ var n = el.querySelector(sel); return n ? n.textContent.replace(/\s+/g,' ').trim() : ''; }
  function sized(u, w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u + (u.indexOf('?')>-1?'&':'?') + 'width=' + w; }

  function productInfo(rev){
    var holder = rev.closest('[data-lr-prod]');
    if (holder) {
      return { url: holder.getAttribute('data-url') || '', title: holder.getAttribute('data-title') || '',
               handle: holder.getAttribute('data-handle') || '', img: holder.getAttribute('data-img') || '' };
    }
    var url = rev.getAttribute('data-product-url') || '';
    var title = rev.getAttribute('data-product-title') || '';
    var a = rev.querySelector('a.jdgm-rev__prod-link, .jdgm-rev__prod-link a, a[href*="/products/"]');
    if (!url && a) url = a.getAttribute('href') || '';
    if (!title && a) title = a.textContent.replace(/\s+/g,' ').trim();
    var m = url.match(/\/products\/([^/?#]+)/);
    return { url: url, title: title, handle: m ? m[1] : '' };
  }

  function rating(rev){
    var r = rev.querySelector('[data-score]');
    var v = r ? parseFloat(r.getAttribute('data-score')) : NaN;
    if (isNaN(v)) v = rev.querySelectorAll('.jdgm--on').length + rev.querySelectorAll('.jdgm--half').length * 0.5;
    return v || 5;
  }

  function photos(rev){
    var out = [];
    rev.querySelectorAll('.jdgm-rev__pics a, .jdgm-rev__pics img, .jdgm-rev__pic-link').forEach(function(n){
      var u = n.tagName === 'A' ? n.getAttribute('href') : (n.getAttribute('data-src') || n.getAttribute('src'));
      if (u && !/data:image/.test(u) && out.indexOf(u) === -1) out.push(u);
    });
    return out.slice(0, 3);
  }

  function loadProductImage(card, handle, img){
    if (img) {
      var s0 = card.querySelector('.lr-prod-img');
      if (s0) s0.innerHTML = '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="120">';
      return;
    }
    if (!handle) return;
    var p = imgCache[handle] || (imgCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }));
    p.then(function(prod){
      if (!prod || !prod.featured_image) return;
      var slot = card.querySelector('.lr-prod-img');
      if (slot) slot.innerHTML = '<img src="' + sized(prod.featured_image, 240) + '" alt="' + esc(prod.title) + '" loading="lazy" width="120" height="120">';
      var name = card.querySelector('.lr-prod-name');
      if (name && !name.textContent) name.textContent = prod.title;
    });
  }

  function build(){
    if (built) return true;
    var revs = box.querySelectorAll('.lr-source .jdgm-rev');
    if (!revs.length) return false;
    built = true;
    var html = '', list = [], seenIds = {}, n = 0;
    revs.forEach(function(rev){
      if (n >= 12) return;
      var rid = rev.getAttribute('data-review-id');
      if (rid) { if (seenIds[rid]) return; seenIds[rid] = true; }
      var body = txt(rev, '.jdgm-rev__body');
      if (!body) return;
      n++;
      var p = productInfo(rev);
      var r = rating(rev);
      var pics = photos(rev);
      var verified = rev.getAttribute('data-verified-buyer') === 'true' || !!rev.querySelector('.jdgm-rev__buyer-badge');
      list.push(p);
      html += '<article class="lr-card">' +
        '<a class="lr-prod" href="' + esc(p.url || '#') + '"><span class="lr-prod-img"></span><span class="lr-prod-name">' + esc(p.title) + '</span></a>' +
        '<span class="vr-stars" style="--pct:' + (r * 20) + '%" aria-label="' + r + ' out of 5 stars">★★★★★</span>' +
        (txt(rev, '.jdgm-rev__title') ? '<b class="lr-title">' + esc(txt(rev, '.jdgm-rev__title')) + '</b>' : '') +
        '<p class="lr-body">' + esc(body) + '</p>' +
        (pics.length ? '<div class="lr-pics">' + pics.map(function(u){ return '<img src="' + esc(sized(u, 200)) + '" alt="Customer photo" loading="lazy">'; }).join('') + '</div>' : '') +
        '<div class="lr-foot"><span class="lr-author">' + esc(txt(rev, '.jdgm-rev__author') || 'Collector') + '</span>' +
        (verified ? '<span class="lr-verified">Verified buyer</span>' : '') + '</div>' +
        '</article>';
    });
    if (!html) { built = false; return false; }
    track.innerHTML = html;
    var cards = track.querySelectorAll('.lr-card');
    list.forEach(function(p, i){ loadProductImage(cards[i], p.handle, p.img); });
    shell.hidden = false;
    box.setAttribute('data-state', 'live');
    var sum = box.querySelector('.lr-summary');
    if (sum && sum.hidden) {
      var total = 0; cards.forEach(function(c){ total += parseFloat(c.querySelector('.vr-stars').style.getPropertyValue('--pct')) / 20; });
      var avg = total / cards.length;
      sum.querySelector('.vr-stars').style.setProperty('--pct', (avg * 20) + '%');
      sum.querySelector('[data-lr-avg]').textContent = avg.toFixed(1);
      sum.querySelector('[data-lr-count]').textContent = cards.length;
      sum.hidden = false;
    }
    return true;
  }

  function scroll(dir){
    var card = track.querySelector('.lr-card');
    var step = card ? card.getBoundingClientRect().width + 16 : 300;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }
  box.querySelector('.lr-prev').addEventListener('click', function(){ scroll(-1); });
  box.querySelector('.lr-next').addEventListener('click', function(){ scroll(1); });

  /* nothing in the page yet: ask Judge.me for each reviewed product's reviews */
  var fetched = false;
  function fetchFromJudgeMe(){
    if (fetched) return; fetched = true;
    var shopEl = box.querySelector('[data-lr-shop]'), shop = '';
    try { shop = JSON.parse(shopEl ? shopEl.textContent : '""'); } catch(e) {}
    var holders = box.querySelectorAll('[data-lr-prod]');
    if (!shop || !holders.length) return;
    holders.forEach(function(h){
      if (h.querySelector('.jdgm-rev')) return;
      var id = h.getAttribute('data-id');
      var u = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
              '&platform=shopify&page=1&per_page=5&product_id=' + encodeURIComponent(id);
      fetch(u).then(function(r){ return r.ok ? r.json() : null; }).then(function(d){
        if (!d || !d.html) return;
        h.insertAdjacentHTML('beforeend', d.html);
        if (built) { built = false; }
        build();
      }).catch(function(){});
    });
  }

  if (build()) return;
  var tries = 0, iv = setInterval(function(){
    src = box.querySelector('.lr-source') || src;
    if (tries === 3) fetchFromJudgeMe();
    if (build() || ++tries > 60) { clearInterval(iv); if (!built) box.setAttribute('data-state', 'fallback'); }
  }, 500);
})();

/* ---------- 16) Bundle offer before checkout ----------
   Catches the Check out button (cart drawer + cart page), picks the bundle that best
   matches what's in the cart, and offers it once per visit. Data comes from snippets/bundle-offer.liquid. */
(function(){
  var veil = document.getElementById('BundleOffer');
  var dataEl = document.getElementById('VioraBundles');
  if (!veil || !dataEl) return;
  var bundles; try { bundles = JSON.parse(dataEl.textContent) || []; } catch(e) { return; }
  if (!bundles.length) return;
  var SEEN = 'vr_bundle_offer_seen', pick = null, go = null, busy = false;

  function seen(){ try { return sessionStorage.getItem(SEEN) === '1'; } catch(e){ return false; } }
  function markSeen(){ try { sessionStorage.setItem(SEEN, '1'); } catch(e){} }
  function money(c){ return '$' + (c/100).toFixed(2); }

  // cart words -> bundle title keywords, best first
  var RULES = [
    { has: ['briefcase'], want: ['trio','shelf','graded display'] },
    { has: ['psa ', 'art rare', 'illustration rare', 'single'], want: ['show','trio','shelf','graded display','vault'] },
    { has: ['storage'], want: ['hit','pack'] },
    { has: ['magnetic','one-touch','one touch'], want: ['pack','hit','chase'] },
    { has: ['elite trainer','booster','etb'], want: ['rip','pulled'] },
    { has: ['semi','saver'], want: ['submission','show'] },
    { has: ['sleeve','toploader','top loader'], want: ['rip','pulled','submission'] },
    { has: ['wood','stand','display'], want: ['trio','shelf','chase','graded display'] },
    { has: ['graded','slab'], want: ['show','vault','trio','graded display'] }
  ];
  // the reason line shown in the popup, picked from the bundle's name
  var WHY = [
    ['show', 'Headed to a card show? This is everything you need.'],
    ['trio', 'Give your slabs a proper place to stand.'],
    ['shelf', 'Give your slabs a proper place to stand.'],
    ['graded display', 'Give your slabs a proper place to stand.'],
    ['vault', 'Lock up the whole collection.'],
    ['hit', 'Fill it with one-touches. Every hit deserves one.'],
    ['pack', 'Stock up. Every hit deserves a one-touch.'],
    ['chase', 'Show off your best card the right way.'],
    ['rip', 'Protect every pull the second it comes out.'],
    ['pulled', 'Sleeves are step one. This covers the rest.'],
    ['submission', 'Everything PSA asks for, in one box.'],
    ['gift', 'The easiest gift for any collector.']
  ];
  function whyFor(b){
    var t = b.title.toLowerCase();
    for (var i = 0; i < WHY.length; i++) if (t.indexOf(WHY[i][0]) > -1) return WHY[i][1];
    return 'Pairs perfectly with what is in your cart.';
  }

  function choose(cart){
    var inCart = {}, text = '', total = cart.total_price || 0;
    (cart.items || []).forEach(function(it){ inCart[it.product_id] = 1; text += ' ' + (it.product_title || it.title || '').toLowerCase(); });
    var hasBriefcase = text.indexOf('briefcase') > -1;
    var pool = bundles.filter(function(b){
      if (!b.available || inCart[b.pid]) return false;
      // never offer a bundle that would double up an expensive item already in the cart ($20+)
      if ((b.items || []).some(function(c){ return inCart[c.pid] && c.price >= 2000; })) return false;
      if (hasBriefcase && !(b.items || []).length && /show|ultimate|store|vault/.test(b.title.toLowerCase())) return false;
      return true;
    });
    if (!pool.length) return null;
    function byKeys(keys){
      var out = [];
      keys.forEach(function(k){ pool.forEach(function(b){ if (b.title.toLowerCase().indexOf(k) > -1 && out.indexOf(b) === -1) out.push(b); }); });
      return out;
    }
    var cap = Math.max(total * 1.25, 1500); // keep the offer in proportion to the order
    for (var r = 0; r < RULES.length; r++) {
      var rule = RULES[r];
      if (!rule.has.some(function(h){ return text.indexOf(h) > -1; })) continue;
      var list = byKeys(rule.want).filter(function(b){ return b.price <= cap; });
      if (list.length) return { b: list[0], why: whyFor(list[0]) };
    }
    var fallback = byKeys(['gift','rip','pulled','chase']).concat(pool).filter(function(b){ return b.price <= cap; });
    return fallback.length ? { b: fallback[0], why: whyFor(fallback[0]) } : null;
  }

  function fill(p){
    var b = p.b;
    veil.querySelector('[data-bo-why]').textContent = p.why;
    veil.querySelector('[data-bo-name]').textContent = b.title;
    veil.querySelector('[data-bo-desc]').textContent = b.desc || '';
    var price = money(b.price) + (b.compare > b.price ? ' <s>' + money(b.compare) + '</s>' : '');
    veil.querySelector('[data-bo-price]').innerHTML = price;
    var img = veil.querySelector('[data-bo-img]');
    img.querySelectorAll('img').forEach(function(n){ n.remove(); });
    if (b.img) { var im = new Image(); im.src = b.img; im.alt = b.title; im.loading = 'eager'; img.insertBefore(im, img.firstChild); }
    var ref = b.compare > b.price ? b.compare : (b.sep > b.price ? b.sep : 0);
    if (ref && !(b.compare > b.price)) veil.querySelector('[data-bo-price]').innerHTML = money(b.price) + ' <s>' + money(ref) + '</s>';
    var save = veil.querySelector('[data-bo-save]');
    if (ref) { save.textContent = 'Save ' + money(ref - b.price).replace('.00',''); save.hidden = false; } else save.hidden = true;

    var inc = veil.querySelector('[data-bo-inc]'), list = veil.querySelector('[data-bo-list]');
    var items = b.items || [];
    if (items.length) {
      list.innerHTML = items.map(function(c){
        return '<li><span class="bo-i-img">' + (c.img ? '<img src="' + c.img + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="bo-i-q">' + c.q + '×</span><span class="bo-i-t"></span></li>';
      }).join('');
      list.querySelectorAll('.bo-i-t').forEach(function(n, i){ n.textContent = items[i].t; });
      inc.hidden = false;
      veil.querySelector('[data-bo-desc]').textContent = '';
    } else { inc.hidden = true; list.innerHTML = ''; }
  }

  function open(){ veil.hidden = false; requestAnimationFrame(function(){ veil.classList.add('is-on'); }); document.documentElement.style.overflow = 'hidden'; }
  function close(){ veil.classList.remove('is-on'); document.documentElement.style.overflow = ''; setTimeout(function(){ veil.hidden = true; }, 200); }

  function intercept(proceed){
    if (seen() || busy) return false;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        busy = false;
        var p = (cart.item_count > 0) ? choose(cart) : null;
        if (!p || !p.b) { proceed(); return; }
        pick = p.b; go = proceed; markSeen(); fill(p); open();
      })
      .catch(function(){ busy = false; proceed(); });
    return true;
  }

  // Cart drawer: capture phase so this runs before the drawer's own checkout handler
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#VDCheckout');
    if (!btn || seen()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!intercept(function(){ window.location.href = '/checkout'; })) window.location.href = '/checkout';
  }, true);

  // Cart page: the form's Check out button
  document.addEventListener('submit', function(e){
    var form = e.target;
    var sub = e.submitter;
    if (!form.matches('form[action*="/cart"]') || !sub || sub.name !== 'checkout' || seen()) return;
    e.preventDefault();
    var proceed = function(){
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; form.appendChild(h);
      HTMLFormElement.prototype.submit.call(form);
    };
    if (!intercept(proceed)) proceed();
  }, true);

  veil.addEventListener('click', function(e){
    if (e.target === veil || e.target.closest('[data-bo-close]')) { close(); return; }
    if (e.target.closest('[data-bo-skip]')) { close(); if (go) go(); return; }
    var add = e.target.closest('[data-bo-add]');
    if (add && pick && !add.disabled) {
      add.disabled = true; add.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: pick.vid, quantity: 1 }) })
        .then(function(){ if (go) go(); })
        .catch(function(){ if (go) go(); });
    }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !veil.hidden) close(); });
})();

})();
